import {z} from 'zod';

export const ChangeOrderVariantFormSchema = z.object({
  orderVariant: z.string().min(1),
});

export type ChangeOrderVariantFormType = z.infer<typeof ChangeOrderVariantFormSchema>;
